exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Vipz{width:100%;margin:auto;font-weight:400;margin-bottom:20px}._2PZQ0,._3Vipz{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2PZQ0{margin:auto;color:red;font-size:21px;line-height:24px;font-weight:700;margin-bottom:3px}", ""]);

// exports
exports.locals = {
	"root": "_3Vipz",
	"title": "_2PZQ0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SoldMessage/SoldMessage.css
// module id = 3273
// module chunks = 32